import { filterSlice } from 'reducers/tanStackTable';
export const tanStackTableActions = filterSlice.actions;
